import {
    CompassOutlined,
    GiftOutlined,
    HomeOutlined,
    UserOutlined,
    WalletOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import './BottomNav.css';

const TABS = [
    { to: '/home', icon: HomeOutlined, labelKey: 'nav.home', end: true },
    { to: '/explore', icon: CompassOutlined, labelKey: 'nav.explore', end: false },
    { to: '/wallet', icon: WalletOutlined, labelKey: 'nav.wallet', end: false },
    { to: '/vouchers', icon: GiftOutlined, labelKey: 'nav.vouchersTab', end: false },
    { to: '/account', icon: UserOutlined, labelKey: 'nav.account', end: false },
] as const;

function BottomNav() {
    const { t } = useTranslation('common');

    return (
        <nav className="bottom-nav" aria-label={t('a11y.primaryNav')}>
            {TABS.map((tab) => {
                const Icon = tab.icon;
                return (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        end={tab.end}
                        className={({ isActive }) =>
                            `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`
                        }
                    >
                        <Icon />
                        <span>{t(tab.labelKey)}</span>
                    </NavLink>
                );
            })}
        </nav>
    );
}

export default BottomNav;
